import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const memberMasterService = createApi({
  reducerPath: "memberMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["memberMaster"],
  endpoints: (builder) => ({
    getAllMemberMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.getAllMemberMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAllMemberMasterBySearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.getAllMemberMasterBySearch}`,
          method: "POST",
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateMemberMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.updateMemberMaster}/${body.id}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteMemberMaster: builder.mutation({
      query(body) {
        return {
           headers: { Authorization: `Bearer ${body.token}` },
          url: `${userManagement.memberMasterController.deleteMemberMaster}/${body.id}`,
          method: "DELETE",
        };
      },
    }),
    getMemberMasterById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.getMemberMasterById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveMemberMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.saveMemberMaster}`,
          method: "POST",
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    findAllMemberMasterMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.findAllMemberMasterMaster}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    bulkSaveMemberMasterMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberMasterController.bulkSaveMemberMasterMaster}`,
          method: 'POST',
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useGetAllMemberMasterMutation,
  useGetAllMemberMasterBySearchMutation,
  useUpdateMemberMasterMutation,
  useDeleteMemberMasterMutation,
  useGetMemberMasterByIdMutation,
  useSaveMemberMasterMutation,
  useFindAllMemberMasterMasterMutation,
  useBulkSaveMemberMasterMasterMutation,
} = memberMasterService;
